<template>
  <div>
    <b-container>

      <b-row class="food-container">
        <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center justify-content-center p-3">
          <img :src="food.thumbnail" class="food-img" :alt="food.name"/>
        </b-col>

        <b-col lg="6" md="6" sm="12" class="d-flex flex-column justify-content-center">

          <b-row class="py-3">
            <b-col cols="12" class="d-flex flex-column align-items-center my-3  ">
              <h2 class=" text-center secondary-text">{{ food.name }}</h2>
            </b-col>
            <b-col cols="12" class="d-flex flex-column align-items-center my-3">
              <p class="text-1 h3 text-center" v-html="food.description"/>
            </b-col>
          </b-row>

        </b-col>

        <b-col lg="12" md="12" sm="12" class="d-flex flex-column justify-content-center p-0 m-0">

          <b-row class="m-0 p-0 text-center w-100">
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center my-3">

              <b-button v-if="food.quantity != 0"
                        class="add-to-card shadow-lg p-3 ml-3 stand-up-animation animation-shadow border-0"
                        @click="addToCard(food.id)">
                افزودن به سبد خرید
              </b-button>

              <b-button v-else class="add-to-card shadow-lg p-3 ml-3 stand-up-animation animation-shadow border-0">
                ناموجود
              </b-button>

            </b-col>
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column text-dark align-items-end my-3 pl-0 ml-0">

              <p  v-if="food.offer > 0" class="text-center ml-5">{{food.offer}} تخفیف</p>

              <div class="price text-dark h4 p-3">{{ getFormattedNumber(food.price - food.offer) }} تومان</div>
            </b-col>
          </b-row>

        </b-col>

      </b-row>
    </b-container>

    <b-container fliud>
      <b-row class="d-flex flex-row justify-content-center mb-2 ">
        <h4>غذاهای مشابه</h4>
      </b-row>
      <b-row class="d-flex flex-row justify-content-center p-0">
        <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center"
               v-for="rFood in recommendedFood"
               :key="rFood.id" v-if="rFood.id !== food.id">
          <m-c17 :food="rFood" :basket="basket"/>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import CardContainer from "../Cards/C5/CardContainer";
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "food",
  props: ['foodSlug'],
  components: {CardContainer},
  computed: {
    ...mapGetters({
      food: "Product/getProduct",
      recommendedFood: "Product/getProducts",
      basket: "ShoppingCart/getSidebarBasketData"
    })
  },
  methods: {
    getFormattedNumber(number) {
      return formatNumber(number)
    },
    getCategoryIdList() {
      let categoryFilter = []
      for (let cat in this.food.category) {
        categoryFilter.push(cat.id)
      }
      return categoryFilter
    },
    addToCard(item) {
      if (this.$store.getters["User/isAuthenticated"]) {
        console.log(item);
        const form = {
          product_id: [item],
        }
        this.$store.dispatch("ShoppingCart/addItem", form)
      } else {
        this.$router.push('/login');
      }
    },
    getRecommendedFoods() {
      let categoriesId = []
      this.food.category.forEach(cat => categoriesId.push(cat.id))

      this.$store.commit('Product/setFilters', {key: 'brand', value: [this.food.brand.id]})
      this.$store.commit('Product/setFilters', {key: 'category', value: [categoriesId]})

      let filters = {categories: this.getCategoryIdList(), brands: this.food.brand.slug, is_digital: 0}
      this.$store.dispatch("Product/setProducts", {filters: filters})
    }
  },
  async mounted() {
    window.scrollTo(0, 0);

    await this.$store.dispatch("Product/getProduct", this.foodSlug).then(res => {
      this.getRecommendedFoods()
    })
    if (this.$store.getters["User/isAuthenticated"]) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid")
    }
  }
};
</script>
<style scoped>
.price {
  color: var(--light);
  background-color: var(--secondary);
  clip-path: polygon(100% 0%, 75% 50%, 100% 100%, 0 100%, 0% 50%, 0 0);;
  font-weight: bold;
  min-width: 230px;
  text-align: left;
  max-height: 60px;
}

.food-img {
  border-radius: 4px;
  height: 100%;
  width: 100%;
}

.food-container {
  margin-top: 165px;
  margin-bottom: 70px;
  border: 2px solid var(--gray);
  border-radius: 30px;
}

.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {
  color: #fff;
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 10px 10px 10px rgba(180, 210, 198, 0.4);
}

.add-to-card {
  background-color: var(--primary) !important;
  color: var(--dark) !important;
}

.add-to-card:hover {
  background-color: var(--secondary) !important;
  color: var(--light) !important;
}
</style>
